export const canvasCurrentView = state => state.currentView;

export const canvasPreviewDevice = state => state.previewDevice;

export const canvasHighlightStyle = state => {
  const { top, left, width, height, display } = state.highlight.style;

  return {
    container: { top, left, width, display },
    right: { left: width, height },
    bottom: { top: height },
    left: { height },
  };
};

export const canvasHighlightElement = state => state.highlight.element;



/** WEBPACK FOOTER **
 ** ./src/store/modules/canvas/getters.js
 **/